import { axios } from '@Root/API'

export const edit = (studyProgrammeId, studyLocationId, payload) => {
	return axios.post(`course-session/${studyProgrammeId}/study-location/${studyLocationId}`, payload)
}
